import Identification from '../components/identification/identification'
import Dates from '../components/select-dates/dates'
import Statistics from '../components/agendas-statistics/statistics'
import Upcoming from '../components/upcoming/upcoming'
import Family from '../components/family/family'
import Search from '../components/search/search'
import Tags from '../components/tags/tag'

export default {
  Identification,
  Dates,
  Statistics,
  Upcoming,
  Family,
  Search,
  Tags
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/resources/components.js